<div class="container my-5 px-3 px-lg-0">
  <div class="row">
    <h2 class="license-title">{{ licenseTitle }} Licenses</h2>
    <app-license-description *ngIf="hasOfferings" [title]="licenseTitle"></app-license-description>
  </div>
  <div class="row mb-5 px-5" *ngIf="hasOfferings; else noOfferings">
    <div class="col-12 col-lg-4 my-5" *ngFor="let offer of getSortedOfferings()">
      <app-product-offering [offer]="offer"
                            [product]="product"
                            (addToCartEmitter)="addToCart($event)"></app-product-offering>
    </div>
  </div>
  <ng-template #noOfferings>
    <div class="row mb-5 px-5">
      <div class="text-center my-5">
        <p class="h3 license-missing">This item is not available as {{ article() }} {{ licenseTitle }} License</p>
      </div>
    </div>
  </ng-template>
</div>
